export enum ContractModelVariant {
  API,
  App,
  NewOrderContextData,
}
